export enum Section {
  GENERAL = "general",
  CRITERIA = "criteria",
  VALUE = "value",
  TO_FROM = "to-from",
  PRESENTATION_FORMATTING = "presentation-formatting",
}
